<template>
  <v-container fluid>
    <v-layout row>
      <h1>NTT DATA Technology Radars</h1>
    </v-layout>

    <v-layout row>
      <h3>In the Tech RADAR, trends are mapped against the Digital Focus Areas. In the Biz Radar, trends are mapped
        against the Market Sectors. </h3>
    </v-layout>

    <v-layout row justify-center mt-5>
      <v-flex xs12 md12 xl12>
        <TrendList
            :trends="trendListObjects"
        ></TrendList>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import TrendList from "@/components/Radar/TrendList";
import TimeService from "@/helpers/TimeService";
import ApiService from "@/helpers/APIService";
import UrlsService from "@/helpers/UrlsService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

export default {
  name: "RadarTrendList",
  components: {
    TrendList
  },
  data() {
    return {
      trendListObjects: [],
    }
  },
  created() {
    this.getTrendList();
  },
  methods: {
    getTrendList() {

      let requestUrl = {
        url: UrlsService.getTrends,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {};
      let requestObject = {
        type: "radar",
        urlsInfo: requestUrl,
        data: {
          method: "get",
          data: requestData
        },
      };
      let messages = {
        title: "Get Trend List",
        loading: "Creating",
        error: "Server Error",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(response => {
            this.trendListObjects = response.trends
          })
          .catch(error => {
            console.log(error)
          })
    },
  }
}
</script>

<style scoped>

</style>
